<template>
    <div class="Home">
        <div class="container-fluid">
            <div class="row">
                <div class="col center-text">
                    <h1>{{ WelcomeLabel }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <b-card title="Need Help?" align="center" class="fill-row">
                        <p><font-awesome-icon :icon="['fa', 'envelope']" /> <a href="mailto:portal-support@olivecrest.org">portal-support@olivecrest.org</a></p>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
    library.add(faPhoneVolume);
    import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
    library.add(faEnvelope);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    export default {
        created() {
 
        },
        props: [],
        data: function () {
            return {
                HelpVideos: [
                    {
                        GroupName: "New",
                        Topics: [
                            {
                                Name: "",
                                URL: ""
                            }
                        ]
                    },
                    {
                        GroupName: "Other Topics",
                        Topics: [
                            {
                                Name: "",
                                URL: "StrongFamilies_AddingHostingInquiries_10"
                            },
                            {
                                Name: "",
                                URL: ""
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            OnClientClicked(rowData) {
                console.log("FROM HOME");
                console.log(rowData);
            },
            SecuredAssetURL(fileName) {
                return this.$baseURL + "/API/SecuredAssets/GetMp4Asset?AssetName=" + fileName;
            }
        },
        components: {

        },
        computed: {
            WelcomeLabel: function () {
                let name = this.$store.state.User.PrivateProfile.FirstName;
                let hour = moment().hours();
                let timeOfDay = "Hello"
                if (hour < 3) {
                    timeOfDay = "Good Evening";
                } else if (hour < 12) {
                    timeOfDay = "Good Morning";
                } else if (hour < 18) {
                    timeOfDay = "Good Afternoon";
                } else {
                    timeOfDay = "Good Evening";
                }
                return timeOfDay + " " + name + "!";
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>